import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      data-name="guarantee (1)"
      xmlns="http://www.w3.org/2000/svg"
      width={58.074}
      height={51.641}
      viewBox="0 0 58.074 51.641"
      {...props}
    >
      <path
        data-name="Path 8019"
        d="M30.241 1.392l2.988 3.357 4.045-1.957a1.611 1.611 0 012.224.921l1.476 4.245 4.487-.266a1.611 1.611 0 011.7 1.7l-.261 4.487 4.245 1.476a1.612 1.612 0 01.921 2.224l-1.955 4.05 3.357 2.988a1.611 1.611 0 010 2.407l-3.357 2.988 1.958 4.045a1.611 1.611 0 01-.921 2.224l-4.245 1.476.261 4.487a1.611 1.611 0 01-1.7 1.7l-4.487-.261-1.476 4.245a1.612 1.612 0 01-2.224.921l-4.048-1.957-2.988 3.358a1.611 1.611 0 01-2.407 0l-2.988-3.358-4.045 1.96a1.611 1.611 0 01-2.224-.921l-1.476-4.246-4.487.261a1.611 1.611 0 01-1.7-1.7l.261-4.487-4.247-1.477a1.612 1.612 0 01-.921-2.224l1.958-4.045-3.354-2.989a1.611 1.611 0 010-2.407l3.357-2.988-1.957-4.045a1.611 1.611 0 01.921-2.224l4.245-1.476-.266-4.492a1.611 1.611 0 011.7-1.7l4.487.261 1.476-4.245a1.612 1.612 0 012.227-.916l4.045 1.958 2.988-3.358a1.611 1.611 0 012.407 0z"
        fill="#ffd164"
      />
      <path
        data-name="Path 8020"
        d="M53.467 24.617l-3.357-2.988 1.958-4.045a1.611 1.611 0 00-.921-2.224l-4.245-1.476.261-4.487a1.611 1.611 0 00-1.7-1.7l-4.487.261L39.5 3.713a1.611 1.611 0 00-2.224-.921l-1.454.7 1.94 5.58a3.4 3.4 0 003.412 2.28l2.477-.144-.144 2.477a3.4 3.4 0 002.277 3.415l2.344.815-1.081 2.233a3.4 3.4 0 00.8 4.025l1.854 1.65-1.854 1.65a3.4 3.4 0 00-.8 4.025l1.081 2.233-2.344.815a3.4 3.4 0 00-2.28 3.412l.144 2.477-2.477-.144a3.4 3.4 0 00-3.412 2.28l-.815 2.344-2.233-1.081a3.4 3.4 0 00-4.025.8l-1.65 1.854-1.65-1.854a3.4 3.4 0 00-4.025-.8l-2.233 1.081-.815-2.344a3.4 3.4 0 00-3.412-2.28l-5.9.343-.094 1.613a1.611 1.611 0 001.7 1.7l4.487-.261 1.476 4.245a1.611 1.611 0 002.224.921l4.045-1.958 2.988 3.357a1.611 1.611 0 002.407 0l2.988-3.357 4.045 1.958a1.611 1.611 0 002.224-.921l1.476-4.245 4.487.261a1.611 1.611 0 001.7-1.7l-.261-4.487 4.245-1.476a1.611 1.611 0 00.921-2.224l-1.958-4.045 3.357-2.988a1.611 1.611 0 00.009-2.41z"
        fill="#ffe17d"
      />
      <circle
        data-name="Ellipse 398"
        cx={16.189}
        cy={16.189}
        r={16.189}
        transform="translate(12.848 9.631)"
        fill="#ffb545"
      />
      <path
        data-name="Path 8021"
        d="M55.522 36.028H2.551a1.7 1.7 0 01-1.7-1.7v-6.81a1.7 1.7 0 011.7-1.7h52.97a1.7 1.7 0 011.7 1.7v6.806a1.7 1.7 0 01-1.699 1.704z"
        fill="#e6646e"
      />
      <g data-name="Group 400">
        <path
          data-name="Path 8022"
          d="M21.34 21.624h-.283v-4.253a.851.851 0 00-1.452-.6l-1.134 1.134a.851.851 0 00.885 1.4v2.317h-.281a.851.851 0 100 1.7h2.268a.851.851 0 100-1.7z"
        />
        <path
          data-name="Path 8023"
          d="M25.714 16.52a2.555 2.555 0 00-2.552 2.552v1.7a2.552 2.552 0 105.1 0v-1.7a2.555 2.555 0 00-2.548-2.552zm.851 4.253a.851.851 0 11-1.7 0v-1.7a.851.851 0 011.7 0z"
        />
        <path
          data-name="Path 8024"
          d="M31.791 16.52a2.555 2.555 0 00-2.552 2.552v1.7a2.552 2.552 0 105.1 0v-1.7a2.555 2.555 0 00-2.548-2.552zm.851 4.253a.851.851 0 11-1.7 0v-1.7a.851.851 0 011.7 0z"
        />
        <path
          data-name="Path 8025"
          d="M36.167 18.22a.851.851 0 10-.851-.851.851.851 0 00.851.851z"
        />
        <path
          data-name="Path 8026"
          d="M39.415 16.626a.85.85 0 00-1.157.331l-2.835 5.1a.851.851 0 101.487.826l2.835-5.1a.851.851 0 00-.33-1.157z"
        />
        <path
          data-name="Path 8027"
          d="M39.002 21.623a.851.851 0 10.851.85.851.851 0 00-.851-.85z"
        />
        <path
          data-name="Path 8028"
          d="M.851 28.373a.851.851 0 00.851-.851.852.852 0 01.851-.851h52.97a.852.852 0 01.851.851.851.851 0 101.7 0 2.555 2.555 0 00-2.552-2.552h-.817a2.463 2.463 0 00-.673-.989l-2.877-2.56 1.678-3.466a2.463 2.463 0 00-1.408-3.4l-3.638-1.264.224-3.845a2.463 2.463 0 00-2.6-2.6l-3.845.224L40.3 3.432a2.463 2.463 0 00-3.4-1.408l-3.467 1.678-2.56-2.877a2.462 2.462 0 00-3.678 0l-2.56 2.877-3.467-1.678a2.463 2.463 0 00-3.4 1.408l-1.26 3.638-3.845-.224a2.463 2.463 0 00-2.6 2.6l.224 3.845-3.639 1.265a2.463 2.463 0 00-1.408 3.4l1.678 3.466-2.877 2.56a2.463 2.463 0 00-.673.989h-.816A2.555 2.555 0 000 27.522a.851.851 0 00.851.851zm7.679-6.108a.851.851 0 00.2-1.006l-1.958-4.045a.76.76 0 01.435-1.05l4.245-1.476a.851.851 0 00.57-.853l-.261-4.487a.76.76 0 01.8-.8l4.487.261a.85.85 0 00.853-.57l1.476-4.245a.76.76 0 011.05-.435l4.045 1.958a.851.851 0 001.006-.2l2.988-3.357a.76.76 0 011.137 0l2.988 3.357a.851.851 0 001.006.2l4.045-1.959a.76.76 0 011.05.435L40.17 8.24a.851.851 0 00.853.57l4.487-.27a.76.76 0 01.8.8l-.261 4.487a.851.851 0 00.57.853l4.245 1.476a.76.76 0 01.435 1.05l-1.958 4.045a.851.851 0 00.2 1.006l3.04 2.706H13.722a15.352 15.352 0 0115.315-14.481h.006a15.408 15.408 0 0115 12.139.855.855 0 00.831.674.786.786 0 00.178-.019.851.851 0 00.654-1.008 17.041 17.041 0 00-33.688 2.702H5.49z"
        />
        <path
          data-name="Path 8029"
          d="M57.224 33.475a.851.851 0 00-.851.851.852.852 0 01-.851.851H2.552a.852.852 0 01-.851-.851.851.851 0 00-1.7 0 2.555 2.555 0 002.551 2.549h6.54l1.209 1.209-.239 4.106a2.463 2.463 0 002.6 2.6l3.845-.224 1.264 3.638a2.463 2.463 0 003.4 1.408l3.467-1.678 2.56 2.877a2.463 2.463 0 003.678 0l2.56-2.877 3.466 1.678a2.463 2.463 0 003.4-1.408l1.264-3.638 3.845.224a2.463 2.463 0 002.6-2.6l-.239-4.106 1.209-1.209h6.54a2.555 2.555 0 002.552-2.552.851.851 0 00-.851-.851zm-11.171 4.33l.261 4.487a.76.76 0 01-.8.8l-4.487-.261a.851.851 0 00-.853.57l-1.476 4.245a.76.76 0 01-1.05.435L33.6 46.128a.851.851 0 00-1.006.2l-2.988 3.357a.76.76 0 01-1.137 0l-2.988-3.357a.851.851 0 00-1.006-.2l-4.045 1.959a.76.76 0 01-1.05-.435l-1.48-4.246a.849.849 0 00-.853-.57l-4.487.261a.76.76 0 01-.8-.8l.261-4.487a.85.85 0 00-.248-.651l-.273-.284h28.153a15.307 15.307 0 01-20.23.884.851.851 0 10-1.068 1.324 16.96 16.96 0 0010.679 3.773v-.006.006a17 17 0 0012.956-5.981h4.586l-.276.276a.851.851 0 00-.248.656z"
        />
        <path
          data-name="Path 8030"
          d="M4.974 29.223h.624a.851.851 0 100-1.7h-.624a3.4 3.4 0 103.4 3.4.85.85 0 00-.851-.85h-1.47a.851.851 0 100 1.7h.4a1.7 1.7 0 11-1.474-2.552z"
        />
        <path
          data-name="Path 8031"
          d="M9.906 27.522a.85.85 0 00-.851.85v3.079a2.892 2.892 0 005.784 0v-3.079a.851.851 0 00-1.7 0v3.079a1.191 1.191 0 01-2.382 0v-3.079a.85.85 0 00-.851-.85z"
        />
        <path
          data-name="Path 8032"
          d="M18.016 27.522a.85.85 0 00-.8.552l-1.914 5.1a.851.851 0 001.593.6l.112-.3h2.011l.112.3a.851.851 0 101.593-.6l-1.914-5.1a.851.851 0 00-.793-.552zm-.368 4.253l.367-.98.367.98z"
        />
        <path
          data-name="Path 8033"
          d="M26.792 30.075a2.548 2.548 0 00-2.537-2.552h-1.659a.85.85 0 00-.851.85v5.1a.851.851 0 001.7 0v-.851h.454l1.437 1.449a.851.851 0 101.208-1.2l-.762-.768a2.554 2.554 0 001.009-2.035zm-2.537.85h-.808v-1.7h.808a.851.851 0 010 1.7z"
        />
        <path
          data-name="Path 8034"
          d="M30.407 27.522a.851.851 0 00-.8.552l-1.914 5.1a.851.851 0 001.593.6l.112-.3h2.011l.112.3a.85.85 0 101.592-.6l-1.914-5.1a.851.851 0 00-.8-.552zm-.368 4.253l.367-.98.367.98z"
        />
        <path
          data-name="Path 8035"
          d="M37.765 28.373v2.505l-2.206-3.008a.851.851 0 00-1.536.5v5.1a.851.851 0 001.7 0v-2.505l2.206 3.008a.851.851 0 001.537-.5v-5.1a.851.851 0 00-1.7 0z"
        />
        <path
          data-name="Path 8036"
          d="M42.729 34.327a.85.85 0 00.851-.851v-4.253h1.078a.851.851 0 000-1.7h-3.856a.851.851 0 100 1.7h1.077v4.253a.85.85 0 00.85.851z"
        />
        <path
          data-name="Path 8037"
          d="M49.466 29.223a.851.851 0 100-1.7h-2.608a.85.85 0 00-.851.85v5.1a.85.85 0 00.851.851h2.608a.851.851 0 000-1.7h-1.758v-.851h1.077a.851.851 0 000-1.7h-1.077v-.851z"
        />
        <path
          data-name="Path 8038"
          d="M54.744 29.223a.851.851 0 100-1.7h-2.605a.85.85 0 00-.851.85v5.1a.85.85 0 00.851.851h2.608a.851.851 0 000-1.7h-1.758v-.851h1.077a.851.851 0 000-1.7h-1.077v-.851z"
        />
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
